<template>
    <AppHeaderDropdown right no-caret>
        <template slot="header">
            <b-col class="mr-4">
            <span>{{ user.name }}&nbsp;</span>&nbsp;<i class="fa fa-user-circle-o fa-lg user-change" aria-hidden="true"></i>
            </b-col>
            <b-col class="mr-4">
                <span class="user-login">{{ $t("LASTLOGIN") }}: {{formatDate(userItem.last_login)}}</span>
            </b-col>

            <!--<img-->
            <!--src="img/avatars/6.jpg"-->
            <!--class="img-avatar"-->
            <!--alt="admin@bootstrapmaster.com"/>-->
        </template>
        <template slot="dropdown">
            <div>
                <b-dropdown-item :to="{name: RouteUserSettings}"><i class="fa fa-wrench"/> {{ $t("SETTINGS") }}
                </b-dropdown-item>
                <b-dropdown-item @click="logout"><i class="fa fa-lock"/> {{ $t("LOGOUT") }}</b-dropdown-item>
            </div>
        </template>
    </AppHeaderDropdown>
</template>

<script>
    import {HeaderDropdown as AppHeaderDropdown} from '@coreui/vue'
    import routeNames from '@/router/routeNames'
    import {getUser} from "@/services/user";
    import moment from 'moment'
    import {LoginPage} from "@/shared/constants";

    export default {
        name: 'DefaultHeaderDropdown',
        components: {
            AppHeaderDropdown,
        },
        data() {
            return {
                RouteUserSettings: routeNames.RN_USER_SETTINGS,
                userItem:[]
            }
        },

        methods: {
            logout() {
                this.$store.dispatch('auth/actionLogout').then(() => {

                  if (process.env.NODE_ENV === 'production') {

                      window.location.href = LoginPage

                  } else {
                    this.$router.replace({name: routeNames.RN_LOGIN})
                  }
                })
            },
            getUserItem() {
                getUser()
                  .then(response => {
                      this.userItem = response.data
                  })
            },
            formatDate(value){
                if(value){
                    const momentDate = new moment(value)
                    return momentDate.format('DD.MM.YYYY HH:mm')
                } else {
                    return null
                }
            },
        },
        computed: {
            user() {
               return this.$store.getters['user/getUser']
           }
        },
        created(){
            this.getUserItem()
        }
    }
</script>

<style scoped>
.user-change {
    margin-right: 5px;
}
.user-login {
    font-size: 11px;
}
</style>
